import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = ({ onExploreClick, isDarkMode }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 pt-24 overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 -z-10">
        <div className={`absolute inset-0 ${
          isDarkMode
            ? 'bg-gradient-to-br from-velvet via-sapphire-light/20 to-velvet'
            : 'bg-gradient-to-br from-cream via-silver/10 to-cream'
        }`} />
        <div className={`absolute top-1/4 right-1/4 w-96 h-96 rounded-full blur-3xl ${
          isDarkMode ? 'bg-sapphire/10' : 'bg-gold/5'
        }`} />
        <div className={`absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl ${
          isDarkMode ? 'bg-gold/5' : 'bg-sapphire/5'
        }`} />
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto text-center animate-fadeInUp">
        {/* Badge */}
        <div className="inline-block mb-6 px-4 py-2 rounded-full bg-gold/10 dark:bg-gold/20 border border-gold/30 animate-slideInDown">
          <div className="flex items-center space-x-2 text-gold">
            <Sparkles className="h-4 w-4" />
            <span className="text-sm font-semibold">Premium Learning Experience</span>
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-sapphire dark:text-cream-light animate-fadeInUp">
          Study for knowledge,
          <br />
          <span className="bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent">
            not for numbers.
          </span>
        </h1>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto mb-8 font-light leading-relaxed animate-slideInUp" style={{ animationDelay: '0.1s' }}>
          Learn because it changes you. Discover a place where real learning shapes who you become.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 animate-slideInUp" style={{ animationDelay: '0.2s' }}>
          <Button
            onClick={onExploreClick}
            className="btn-gold text-lg px-8 py-6 rounded-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 group"
          >
            <span>Explore Courses</span>
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          
          <Button
            variant="outline"
            className="border-2 border-sapphire dark:border-gold text-sapphire dark:text-gold hover:bg-sapphire hover:text-cream dark:hover:bg-gold dark:hover:text-velvet text-lg px-8 py-6 rounded-lg font-semibold transition-all duration-300"
          >
            Start Learning
          </Button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 sm:gap-8 max-w-2xl mx-auto animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
          <div className="neumorphic-card">
            <div className="text-2xl sm:text-3xl font-bold text-gold">500+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Courses</div>
          </div>
          <div className="neumorphic-card">
            <div className="text-2xl sm:text-3xl font-bold text-gold">50K+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Students</div>
          </div>
          <div className="neumorphic-card">
            <div className="text-2xl sm:text-3xl font-bold text-gold">24/7</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Access</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-sapphire dark:border-gold rounded-full flex justify-center">
          <div className="w-1 h-2 bg-sapphire dark:bg-gold rounded-full mt-2 animate-softPulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
